// TODO remove unnecessary dependency and refactor to Intl
// example: new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'USD' }).format(450001231233 / 10000)

import currency from 'currency.js';

export function moneyFormat(amount: number) {
  return currency(amount, { separator: ' ' }).format();
}
